// import { useState, useEffect } from "react";
// import { useParams, useSearchParams } from "react-router-dom";
// import axios from "axios";
// import { PDFViewer, Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
// import img from '../../assets/restaurant/meteri-logo.png'
// import BannerImg from '../../assets/restaurant/BannerBg.png'
// import bottle from '../../assets/pdf/wine-bottle.png'
// import glass from '../../assets/pdf/wine.png'

// import FontBoldWoff from '../../font/Montserrat-Bold.woff';
// import FontBoldWoff2 from '../../font/Montserrat-Bold.woff2';
// // import defaultImage from "../../utils/DefaultImage";

// Font.register({
//   family: 'Montserrat',
//   fonts: [
//     {
//       src: FontBoldWoff,
//       fontWeight: 'bold',
//     },
//     {
//       src: FontBoldWoff2,
//       fontWeight: 'bold',
//     },
//   ],
// });

// const styles = StyleSheet.create({
//   page: {
//     flexDirection: 'column',
//     backgroundColor: 'white',
//     position: 'relative',
//     height: '100%',
//     boxSizing: 'border-box',
//   },
//   innerPage: {
//     flexDirection: 'column',
//     padding: 25,
//   },
//   backgroundImage: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     backgroundSize: 'cover',
//     backgroundPosition: 'left center',
//     zIndex: -1,
//     opacity: 0.3,
//   },
//   WineBorder: {
//     borderBottom: '1px solid #d8b6ba',

//   },
//   WineListName: {
//     fontSize: 30,
//     marginLeft: 'auto',
//     margin: "25 0 0 0",
//     textAlign: 'center',
//     color: '#7d0a0a',
//     fontWeight: 'extrabold',
//     font: 'MontserratBold',
//     textTransform: 'capitalize',
//   },
//   wineType: {
//     position: 'absolute',
//     fontSize: 17,
//     wordWrap: 'break-word',
//     color: '#5f5f5f',
//     top: '10',
//     // top: '-25',

//     maxWidth: '120',
//     width: '120',
//     left: '45',
//     fontWeight: 'bold',
//   },
//   regionType: {
//     position: 'absolute',
//     fontSize: 17,
//     wordWrap: 'break-word',
//     color: '#5f5f5f',
//     top: '25',
//     // top: '-25',

//     maxWidth: '120',
//     width: '120',
//     left: '45',
//     fontWeight: 'bold',
//   },
//   wineCard: {
//     position: "relative",
//     margin: "40 20 0 40",
//     padding: "8",
//     // borderWidth: 1,
//     // border: "none",
//     borderColor: '#d8b6ba',
//     // borderBottomWidth: 1,
//     flexDirection: 'row',
//     alignItems: 'flex-start',
//   },
//   image: {
//     width: 50,
//     height: 115,
//     marginRight: 25,
//     // borderRadius: 0,
//     // border: "none",
//     borderColor: '#000000',
//   },
//   // LogoImage: {
//   //   marginTop: 10,
//   //   width: 70,
//   //   height: 70,
//   //   marginLeft: 10,
//   //   // border: "none",
//   //   borderColor: '#000000',
//   // },

//   LogoImage: {
//     width: 105,
//     height: 45,
//     position: 'absolute',
//     top: 12,
//     left: 5,
//     zIndex: 10
//   },
//   wineDetails: {
//     flex: 1,
//     paddingTop: "10px",
//     marginLeft: "0px",
//   },
//   wineName: {
//     fontSize: 11,
//     color: '#7d0a0a',
//     marginTop: 10,
//     marginBottom: 0,
//     // font: 'MontserratBold'
//     // fontFamily: 'Montserrat',
//     fontWeight: 'bold',
//   },
//   wineText: {
//     fontSize: 11,
//     color: '#8B2434',
//     marginBottom: 5,
//   },
//   wineDescription: {
//     fontSize: 8,
//     color: '#000000',
//     marginBottom: 5,
//     font: 'MontserratRegular'
//   },
//   wineAddress: {
//     fontSize: 10,
//     color: '#5f5f5f',
//     margin: "8 0",
//     marginLeft: 0,
//     paddingLeft: 0,
//     fontWeight: 'extrabold',
//     textAlign: 'left',
//     textIndent: 0,
//     // font: 'MontserratBold'
//     // fontFamily: 'Montserrat',
//   },
//   // priceContainer: {
//   //   flexDirection: "row",
//   //   alignItems: "center",
//   //   gap: 10,
//   // },
//   winePrice: {
//     fontSize: 12,
//     marginLeft: "auto",
//     marginTop: 20,
//     fontWeight: 'bold',
//     color: '#8B2434',
//   },
//   winePrice1: {
//     fontSize: 12,
//     marginTop: 6,
//     marginLeft: "auto",
//     fontWeight: 'bold',
//     color: '#8B2434',
//   },

//   noWinesContainer: {
//     marginTop: 20,
//     textAlign: "center",
//   },
//   noWinesText: {
//     fontSize: 16,
//     fontWeight: "bold",
//     color: "red",
//   },
// });


// const WinePDF = () => {
//   const { wine_list_name } = useParams();
//   const [searchParams] = useSearchParams();
//   const [restData, setRestData] = useState(null);
//   console.log("🚀 ~ restData:", restData)
//   const criteria = searchParams.get('criteria');
//   console.log("🚀 ~ criteria:", criteria)
//   const [imageLoaded, setImageLoaded] = useState({});
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem("token");
//   const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;

//   // useEffect(() => {
//   //   axios
//   //     .get(`${apiUrl}/api/v1/wine-list/${wine_list_name}`, {
//   //       headers: {
//   //         Authorization: `Bearer ${token}`,
//   //       },
//   //     })
//   //     .then((res) => {
//   //       if (res.status === 200) {
//   //         setRestData(res.data);
//   //       } else {
//   //         setRestData(null);
//   //       }
//   //     })
//   //     .catch((err) => {
//   //       setRestData(null);
//   //       console.error(err);
//   //     });
//   // }, [wine_list_name]);

//   useEffect(() => {
//     setLoading(true);

//     axios
//       .get(`${apiUrl}/api/v1/wine-list/${wine_list_name}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then(async (res) => {
//         if (res.status === 200) {
//           setRestData(res?.data);

//           const imageUrls = res?.data?.wines?.map((item) => item?.wine?.image).filter(Boolean);

//           if (imageUrls.length === 0) {
//             setLoading(false);
//             return;
//           }

//           const imagePromises = imageUrls.map((url, index) =>
//             axios
//               .get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(url)}`, {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                 },
//                 responseType: "blob",
//               })
//               .then((res) => {
//                 if (res.status === 200) {
//                   const imageBlobUrl = URL.createObjectURL(res.data);
//                   setImageLoaded((prev) => {
//                     const updatedLoaded = { ...prev, [index]: imageBlobUrl };
//                     if (Object.keys(updatedLoaded).length === imageUrls.length) {
//                       setLoading(false);
//                     }
//                     return updatedLoaded;
//                   });

//                   return true;
//                 }
//                 return false;
//               })
//               .catch(() => false)
//           );

//           await Promise.all(imagePromises);
//         }
//       })
//       .catch(() => setRestData(null))
//       .finally(() => {
//         setTimeout(() => {
//           if (Object.keys(imageLoaded).length === 0) setLoading(false);
//         }, 1000);
//       });
//   }, [wine_list_name]);

//   const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
//   const logo = restData?.wineList?.
//     restaurant?.logo ? `${logoUrl}/${restData?.wineList?.restaurant?.logo}` : null;

//   const stripHtmlTags = (html) => {
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = html;
//     return tempDiv.textContent || tempDiv.innerText || '';
//   };

//   // if (!restData) {

//   if (loading) {
//     return <div className="flex justify-center items-center h-screen">
//       <svg
//         aria-hidden="true"
//         className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
//         viewBox="0 0 100 101"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//           fill="currentColor"
//         />
//         <path
//           d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//           fill="currentFill"
//         />
//       </svg>
//       <span className="sr-only">Loading...</span>
//     </div>
//   }

//   {/* // Helper function to render wine cards */ }
//   const renderWineCards = (wineData, index) => {
//     return wineData?.map((item, idx) => (
//       <View style={styles.wineCard} key={`${item?.wine?.id || idx}`}>
//         {item?.wine?.image && imageLoaded[index] ? (
//           <Image
//             source={{ uri: imageLoaded[index] }}
//             style={styles.image}
//           />
//         ) : (
//           <Image source={bottle} style={styles.image} />
//         )}

//         {/* Wine Details */}
//         <View style={styles.wineDetails}>
//           <Text style={styles.wineName}>{item?.wine?.name || ""}</Text>
//           <Text style={styles.wineAddress}>
//             {item?.wine?.region && <strong>Region:</strong>} {item?.wine?.region}
//             {item?.wine?.region && item?.wine?.nation ? ", " : ""}
//             {item?.wine?.nation && <strong>Nation:</strong>} {item?.wine?.nation}
//             {(item?.wine?.region || item?.wine?.nation) && item?.wine?.grape_variety ? ", " : ""}
//             {item?.wine?.grape_variety && <strong>Grape Variety:</strong>} {item?.wine?.grape_variety}
//           </Text>
//           <Text style={styles.wineDescription}>
//             {stripHtmlTags(item?.wine?.short_description || "")}
//           </Text>
//         </View>

//         {/* Prices */}
//         <View style={{ width: "14%", gap: 5 }}>
//           {item?.pivot?.is_show_bottle_price && (
//             <Text style={styles.winePrice}>
//               <Image source={bottle} style={styles.priceIcon} />
//               {" €" + item?.pivot?.bottle_price}
//             </Text>
//           )}
//           {item?.pivot?.is_show_glass_price && (
//             <Text style={styles.winePrice1}>
//               <Image source={glass} style={styles.priceIcon} />
//               {" €" + item?.pivot?.glass_price}
//             </Text>
//           )}
//         </View>
//       </View>
//     ));
//   };

//   return (
//     <PDFViewer style={{ width: '100%', height: '100vh' }}>
//       <Document>
//         <Page size="A4" style={styles.page}>
//           <Image
//             style={styles.backgroundImage}
//             src={BannerImg}
//             fixed
//           />

//           {logo ? (
//             <Image
//               src={{
//                 uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
//                 method: "GET",
//                 headers: { Authorization: `Bearer ${token}` },
//               }}
//               style={styles.LogoImage}
//             />
//           ) : (
//             ""
//           )}

//           <Image
//             style={{
//               width: "105px",
//               height: "45px",
//               position: 'absolute',
//               top: 12,
//               right: 5,
//               zIndex: 10
//             }}
//             src={img}
//             fixed
//           />
//           <Text
//             fixed
//             style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               fontSize: 12,
//               fontWeight: 'bold',
//               width: "100%",
//               height: "12px",
//               backgroundColor: "#8B2434"
//             }}></Text>
//           <Text style={styles.WineListName}>{restData?.wineList?.name || ""}</Text>

//           {/* {restData?.wines?.length > 0 ? (
//             [...new Set(restData?.wines?.map((wine) => wine?.wine?.[criteria]))]
//               .filter(type => type)
//               .map((type, index) => {
//                 const typeData = restData?.wines?.filter(
//                   (wine) => wine?.wine?.[criteria] === type
//                 );

//                 const regions = [...new Set(typeData?.map(wine => wine?.wine?.region))]
//                   .filter(region => region)
//                   .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
//                 return (
//                   <View key={`${type}-${index}`} style={styles.WineBorder}>
//                     <Text style={styles.wineType}>{type || ""}</Text>

//                     {regions?.map((region, regionIndex) => {
//                       const regionData = typeData?.filter(
//                         (wine) => wine?.wine?.region === region
//                       );

//                       return (
//                         <View key={`${region}-${regionIndex}`}>
//                           {region && <Text style={styles.regionType}>{region}</Text>}

//                           {regionData?.map((item, idx) => (
//                             <View style={styles.wineCard} key={`${item?.wine?.id || idx}`}>
//                               {item?.wine?.image && imageLoaded[index] ? (
//                                 <Image
//                                   source={{ uri: imageLoaded[index] }}
//                                   style={styles.image}
//                                 />
//                               ) : (
//                                 <Image source={bottle} style={styles.image} />
//                               )}

//                               <View style={styles.wineDetails}>
//                                 <Text style={styles.wineName}>{item?.wine?.name || ""}</Text>
//                                 <Text style={styles.wineAddress}>
//                                   {item?.wine?.region && <strong>Region:</strong>} {item?.wine?.region}
//                                   {item?.wine?.region && item?.wine?.nation ? ", " : ""}
//                                   {item?.wine?.nation && <strong>Nation:</strong>} {item?.wine?.nation}
//                                   {(item?.wine?.region || item?.wine?.nation) && item?.wine?.grape_variety ? ", " : ""}
//                                   {item?.wine?.grape_variety && <strong>Grape Variety:</strong>} {item?.wine?.grape_variety}
//                                 </Text>
//                                 <Text style={styles.wineDescription}>
//                                   {stripHtmlTags(item?.wine?.short_description || "")}
//                                 </Text>
//                               </View>

//                               <View style={{ width: "14%", gap: 5 }}>
//                                 {item?.pivot?.is_show_bottle_price && (
//                                   <Text style={styles.winePrice}>
//                                     <Image source={bottle} style={styles.priceIcon} />
//                                     {" €" + item?.pivot?.bottle_price}
//                                   </Text>
//                                 )}
//                                 {item?.pivot?.is_show_glass_price && (
//                                   <Text style={styles.winePrice1}>
//                                     <Image source={glass} style={styles.priceIcon} />
//                                     {" €" + item?.pivot?.glass_price}
//                                   </Text>
//                                 )}
//                               </View>
//                             </View>
//                           ))}
//                         </View>
//                       );
//                     })}
//                   </View>
//                 );
//               })
//           ) : (
//             <View style={styles.noWinesContainer}>
//               <Text style={styles.noWinesText}>No wines found.</Text>
//             </View>
//           )} */}

//           {restData?.wines?.length > 0 ? (
//             [...new Set(restData?.wines?.map((wine) => wine?.wine?.[criteria]))]
//               .filter(type => type)
//               .map((type, index) => {
//                 const typeData = restData?.wines?.filter(
//                   (wine) => wine?.wine?.[criteria] === type
//                 );
//                 return (
//                   <View key={`${type}-${index}`} style={styles.WineBorder}>
//                     <Text style={styles.wineType}>{type || ""}</Text>

//                     {criteria !== 'product_type' ? (
//                       // Show regions grouping if criteria is not product_type
//                       [...new Set(typeData.map(wine => wine?.wine?.region))]
//                         .filter(region => region)
//                         .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
//                         .map((region, regionIndex) => {
//                           const regionData = typeData.filter(
//                             (wine) => wine?.wine?.region === region
//                           );

//                           return (
//                             <View key={`${region}-${regionIndex}`}>
//                               {region && <Text style={styles.regionType}>{region}</Text>}
//                               {renderWineCards(regionData, index)}
//                             </View>
//                           );
//                         })
//                     ) : (
//                       // Show wines directly without region grouping if criteria is product_type
//                       renderWineCards(typeData, index)
//                     )}
//                   </View>
//                 );
//               })
//           ) : (
//             <View style={styles.noWinesContainer}>
//               <Text style={styles.noWinesText}>No wines found.</Text>
//             </View>
//           )}
//         </Page>
//       </Document>
//     </PDFViewer>
//   );
// };

// export default WinePDF;

// import { useState, useEffect } from "react";
// import { useParams, useSearchParams } from "react-router-dom";
// import axios from "axios";
// import { PDFViewer, Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
// import img from '../../assets/restaurant/meteri-logo.png'
// import BannerImg from '../../assets/restaurant/BannerBg.png'
// import bottle from '../../assets/pdf/wine-bottle.png'
// import glass from '../../assets/pdf/wine.png'

// import FontBoldWoff from '../../font/Montserrat-Bold.woff';
// import FontBoldWoff2 from '../../font/Montserrat-Bold.woff2';
// // import defaultImage from "../../utils/DefaultImage";

// Font.register({
//   family: 'Montserrat',
//   fonts: [
//     {
//       src: FontBoldWoff,
//       fontWeight: 'bold',
//     },
//     {
//       src: FontBoldWoff2,
//       fontWeight: 'bold',
//     },
//   ],
// });

// const styles = StyleSheet.create({
//   page: {
//     flexDirection: 'column',
//     backgroundColor: 'white',
//     position: 'relative',
//     height: '100%',
//     boxSizing: 'border-box',
//   },
//   innerPage: {
//     flexDirection: 'column',
//     padding: 25,
//   },
//   backgroundImage: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     backgroundSize: 'cover',
//     backgroundPosition: 'left center',
//     zIndex: -1,
//     opacity: 0.3,
//   },
//   WineBorder: {
//     borderBottom: '1px solid #d8b6ba',

//   },
//   WineListName: {
//     fontSize: 30,
//     marginLeft: 'auto',
//     margin: "25 0 0 0",
//     textAlign: 'center',
//     color: '#7d0a0a',
//     fontWeight: 'extrabold',
//     font: 'MontserratBold',
//     textTransform: 'capitalize',
//   },
//   wineType: {
//     // position: 'absolute',
//     fontSize: 20,
//     wordWrap: 'break-word',
//     color: '#5f5f5f',
//     top: '10',
//     // top: '-25',

//     maxWidth: '150',
//     width: '150',
//     left: '45',
//     fontWeight: 'bold',
//   },
//   regionType: {
//     // position: 'absolute',
//     fontSize: 15,
//     wordWrap: 'break-word',
//     color: '#5f5f5f',
//     top: '15',
//     // top: '-25',

//     maxWidth: '120',
//     width: '120',
//     left: '45',
//     fontWeight: 'bold',
//   },
//   wineCard: {
//     position: "relative",
//     margin: "20 20 0 40",
//     padding: "20 8 10 8",
//     // borderWidth: 1,
//     // border: "none",
//     borderColor: '#d8b6ba',
//     // borderBottomWidth: 1,
//     flexDirection: 'row',
//     alignItems: 'flex-start',
//   },
//   image: {

//     width: '100%',
//     height: '100%',
//     objectFit: 'cover'
//   },
//   mainimg: {
//     width: 50,
//     height: 115,
//     marginRight: 25,
//     objectFit: 'content',

//     // borderRadius: 0,
//     // border: "none",
//     borderColor: '#000000',
//   },

//   // LogoImage: {
//   //   marginTop: 10,
//   //   width: 70,
//   //   height: 70,
//   //   marginLeft: 10,
//   //   // border: "none",
//   //   borderColor: '#000000',
//   // },

//   LogoImage: {
//     width: 105,
//     height: 45,
//     position: 'absolute',
//     top: 12,
//     left: 5,
//     zIndex: 10
//   },
//   wineDetails: {
//     flex: 1,
//     paddingTop: "10px",
//     marginLeft: "0px",
//   },
//   wineName: {
//     fontSize: 11,
//     color: '#7d0a0a',
//     marginTop: 10,
//     marginBottom: 0,
//     // font: 'MontserratBold'
//     // fontFamily: 'Montserrat',
//     fontWeight: 'bold',
//   },
//   wineText: {
//     fontSize: 11,
//     color: '#8B2434',
//     marginBottom: 5,
//   },
//   wineDescription: {
//     fontSize: 8,
//     color: '#000000',
//     marginBottom: 5,
//     font: 'MontserratRegular',
//     textAlign: 'justify',
//     lineHeight: '13px',

//   },
//   wineAddress: {
//     fontSize: 10,
//     color: '#5f5f5f',
//     margin: "8 0",
//     marginLeft: 0,
//     paddingLeft: 0,
//     fontWeight: 'extrabold',
//     textAlign: 'left',
//     textIndent: 0,
//     // font: 'MontserratBold'
//     // fontFamily: 'Montserrat',
//   },
//   // priceContainer: {
//   //   flexDirection: "row",
//   //   alignItems: "center",
//   //   gap: 10,
//   // },
//   winePrice: {
//     fontSize: 12,
//     marginLeft: "auto",
//     marginTop: 20,
//     fontWeight: 'bold',
//     color: '#8B2434',
//   },
//   winePrice1: {
//     fontSize: 12,
//     marginTop: 6,
//     marginLeft: "auto",
//     fontWeight: 'bold',
//     color: '#8B2434',
//   },

//   noWinesContainer: {
//     marginTop: 20,
//     textAlign: "center",
//   },
//   noWinesText: {
//     fontSize: 16,
//     fontWeight: "bold",
//     color: "red",
//   },
// });

// const WinePDF = () => {
//   const { wine_list_name } = useParams();
//   const [searchParams] = useSearchParams();
//   const [restData, setRestData] = useState(null);
//   const criteria = searchParams.get('criteria');
//   const [imageLoaded, setImageLoaded] = useState({});
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem("token");
//   const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;

//   useEffect(() => {
//     setLoading(true);

//     axios
//       .get(`${apiUrl}/api/v1/wine-list/${wine_list_name}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then(async (res) => {
//         if (res.status === 200) {
//           setRestData(res?.data);

//           // Create an array of objects with wine id and image URL
//           const wineImages = res?.data?.wines
//             ?.map((item) => ({
//               id: item?.wine?.id,
//               url: item?.wine?.image
//             }))
//             .filter(item => item.url);

//           if (wineImages.length === 0) {
//             setLoading(false);
//             return;
//           }

//           const imagePromises = wineImages.map((wineImage) =>
//             axios
//               .get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(wineImage.url)}`, {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                 },
//                 responseType: "blob",
//               })
//               .then((res) => {
//                 if (res.status === 200) {
//                   const imageBlobUrl = URL.createObjectURL(res.data);
//                   setImageLoaded((prev) => {
//                     const updatedLoaded = {
//                       ...prev,
//                       [wineImage.id]: imageBlobUrl
//                     };
//                     if (Object.keys(updatedLoaded).length === wineImages.length) {
//                       setLoading(false);
//                     }
//                     return updatedLoaded;
//                   });
//                   return true;
//                 }
//                 return false;
//               })
//               .catch(() => false)
//           );

//           await Promise.all(imagePromises);
//         }
//       })
//       .catch(() => setRestData(null))
//       .finally(() => {
//         setTimeout(() => {
//           if (Object.keys(imageLoaded).length === 0) setLoading(false);
//         }, 1000);
//       });
//   }, [wine_list_name]);

//   const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
//   const logo = restData?.wineList?.restaurant?.logo ?
//     `${logoUrl}/${restData?.wineList?.restaurant?.logo}` : null;

//   const stripHtmlTags = (html) => {
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = html;
//     return tempDiv.textContent || tempDiv.innerText || '';
//   };

//   if (loading) {
//     return <div className="flex justify-center items-center h-screen">
//       <svg
//         aria-hidden="true"
//         className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
//         viewBox="0 0 100 101"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//           fill="currentColor"
//         />
//         <path
//           d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//           fill="currentFill"
//         />
//       </svg>
//       <span className="sr-only">Loading...</span>
//     </div>
//   }

//   const renderWineCards = (wineData) => {
//     return wineData?.map((item) => (
//       <View style={styles.wineCard} key={item?.wine?.id}>
//         <View style={styles.mainimg}>
//           {item?.wine?.image && imageLoaded[item?.wine?.id] ? (
//             <Image
//               source={{ uri: imageLoaded[item?.wine?.id] }}
//               style={styles.image}
//             />
//           ) : (
//             <Image source={bottle} style={styles.image} />
//           )}
//         </View>


//         <View style={styles.wineDetails}>
//           <Text style={styles.wineName}>{item?.wine?.name || ""}</Text>
//           <Text style={styles.wineAddress}>
//             {item?.wine?.region && <strong>Region:</strong>}{item?.wine?.region}
//             {item?.wine?.region && item?.wine?.nation ? ", " : ""}
//             {item?.wine?.nation && <strong>Nation:</strong>} {item?.wine?.nation}
//             {(item?.wine?.region || item?.wine?.nation) && item?.wine?.grape_variety ? ", " : ""}
//             {item?.wine?.grape_variety && <strong>Grape Variety:</strong>} {item?.wine?.grape_variety}
//           </Text>
//           <Text style={styles.wineDescription}>
//             {stripHtmlTags(item?.wine?.short_description || "")}
//           </Text>
//         </View>

//         <View style={{ width: "14%", gap: 5 }}>
//           {item?.pivot?.is_show_bottle_price && (
//             <Text style={styles.winePrice}>
//               <Image source={bottle} style={styles.priceIcon} />
//               {" €" + item?.pivot?.bottle_price}
//             </Text>
//           )}
//           {item?.pivot?.is_show_glass_price && (
//             <Text style={styles.winePrice1}>
//               <Image source={glass} style={styles.priceIcon} />
//               {" €" + item?.pivot?.glass_price}
//             </Text>
//           )}
//         </View>
//       </View>
//     ));
//   };

//   return (
//     <PDFViewer style={{ width: '100%', height: '100vh' }}>
//       <Document>
//         <Page size="A4" style={styles.page}>
//           <Image
//             style={styles.backgroundImage}
//             src={BannerImg}
//             fixed
//           />

//           {logo ? (
//             <Image
//               src={{
//                 uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
//                 method: "GET",
//                 headers: { Authorization: `Bearer ${token}` },
//               }}
//               style={styles.LogoImage}
//             />
//           ) : (
//             ""
//           )}

//           <Image
//             style={{
//               width: "105px",
//               height: "45px",
//               position: 'absolute',
//               top: 12,
//               right: 5,
//               zIndex: 10
//             }}
//             src={img}
//             fixed
//           />
//           <Text
//             fixed
//             style={{
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               fontSize: 12,
//               fontWeight: 'bold',
//               width: "100%",
//               height: "12px",
//               backgroundColor: "#8B2434"
//             }}></Text>
//           <Text style={styles.WineListName}>{restData?.wineList?.name || ""}</Text>

//           {restData?.wines?.length > 0 ? (
//             [...new Set(restData?.wines?.map((wine) => wine?.wine?.[criteria]))]
//               .filter(type => type)
//               .map((type) => {
//                 const typeData = restData?.wines?.filter((wine) => wine?.wine?.[criteria] === type);
//                 return (
//                   <View key={type} style={styles.WineBorder}>
//                     <Text style={styles.wineType}>{type || ""}</Text>

//                     {criteria !== 'product_type' ? (
//                       [...new Set(typeData.map(wine => wine?.wine?.region))]
//                         .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
//                         .map((region) => {
//                           const regionData = typeData.filter(
//                             (wine) => wine?.wine?.region === region
//                           );
//                           return (
//                             <View key={region}>
//                               {region && <Text style={styles.regionType}>{region}</Text>}
//                               {renderWineCards(regionData)}
//                             </View>
//                           );
//                         })
//                     ) : (
//                       renderWineCards(typeData)
//                     )}
//                   </View>
//                 );
//               })
//           ) : (
//             <View style={styles.noWinesContainer}>
//               <Text style={styles.noWinesText}>No wines found.</Text>
//             </View>
//           )}
//         </Page>
//       </Document>
//     </PDFViewer>
//   );
// };

// export default WinePDF;





// import { useState, useEffect } from "react";
// import { useParams, useSearchParams } from "react-router-dom";
// import axios from "axios";
// import { PDFViewer, Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
// import img from '../../../assets/restaurant/meteri-logo.png'
// import BannerImg from '../../../assets/restaurant/BannerBg.png'
// import bottle from '../../../assets/pdf/wine-bottle.png'
// import glass from '../../../assets/pdf/wine.png'

// import FontBoldWoff from '../../../assets/font/Montserrat-Bold.woff';
// import FontBoldWoff2 from '../../../assets/font/Montserrat-Bold.woff2';

// import FontBoldWoff3 from '../../../assets/font/MontserratAlternates-MediumItalic.woff';
// import FontBoldWoff4 from '../../../assets/font/MontserratAlternates-MediumItalic.woff2';

// import { toast } from "react-toastify";

// // Soft break words longer
// Font.registerHyphenationCallback((word) => {
//   if (word.length > 15) {
//     return word.match(/.{1,10}/g);
//   }
//   return [word];
// });


// Font.register({
//   family: 'Montserrat',
//   fonts: [
//     {
//       src: FontBoldWoff,
//       fontWeight: 'bold',
//     },
//     {
//       src: FontBoldWoff2,
//       fontWeight: 'bold',
//     },
//     {
//       src: FontBoldWoff3,
//       fontWeight: 100,
//     },
//     {
//       src: FontBoldWoff4,
//       fontWeight: 100,
//     },
//   ],
// });

// const styles = StyleSheet.create({
//   page: {
//     flexDirection: 'column',
//     backgroundColor: 'white',
//     padding: 20,
//     fontSize: 12,
//   },
//   backgroundImage: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundSize: 'cover',
//     backgroundPosition: 'left center',
//     zIndex: -1,
//     opacity: 0.3,
//   },
//   WineBorder: {
//     borderTop: '1px solid #d8b6ba',
//     marginBottom: 5,
//     marginTop: 10,
//     marginLeft: -20,
//     marginRight: -20,
//     paddingHorizontal: 20,
//   },
//   WineListName: {
//     maxWidth: '310px',
//     // margin: '0 auto',
//     margin: '20px auto 10px',
//     fontSize: 18,
//     textAlign: 'left',
//     color: '#7d0a0a',
//     fontWeight: 'bold',
//     fontFamily: 'Montserrat',
//     textTransform: 'capitalize',
//     wordWrap: 'break-word',
//     overflow: 'hidden',
//     maxHeight: '70px',
//     whiteSpace: 'nowrap',
//     textOverflow: 'ellipsis',
//   },
//   WineListDescription: {
//     maxWidth: "480px",
//     width: "100%",
//     fontSize: 11,
//     textAlign: "center",
//     color: "#7d0a0a",
//     fontWeight: 100,
//     fontFamily: "Montserrat",
//     textTransform: "capitalize",
//     wordWrap: "break-word",
//     overflow: "hidden",
//     lineHeight: "13px",
//     margin: "auto",
//     marginBottom: -20,
//   },
//   wineType: {
//     fontSize: 20,
//     color: '#5f5f5f',
//     fontWeight: 'bold',
//     // marginBottom: 10,
//     marginTop: 10,
//     marginLeft: 20,
//   },
//   regionType: {
//     fontSize: 15,
//     color: '#5f5f5f',
//     fontWeight: 'bold',
//     marginBottom: 5,
//     textAlign: 'left',
//     marginLeft: 20,
//   },
//   wineCard: {
//     flexDirection: 'row',
//     alignItems: 'flex-start',
//     // marginBottom: 20,
//     paddingBottom: 15,
//     paddingTop: 5,
//     gap: 10,
//     // borderBottom: '1px solid #f0f0f0',
//     pageBreakInside: 'avoid',
//   },
//   image: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover'
//   },
//   mainimg: {
//     width: 30,
//     height: 115,
//     marginRight: 5,
//   },
//   LogoImage: {
//     width: 105,
//     height: 45,
//     position: 'absolute',
//     top: 12,
//     left: 5, // Match content padding
//     zIndex: 10
//   },
//   LogoImage1: {
//     width: 105,
//     height: 45,
//     position: 'absolute',
//     top: 12,
//     right: 10,
//     zIndex: 10
//   },
//   wineDetails: {
//     flex: 1,
//     paddingTop: 10, 
//     flexDirection: 'column',
//     alignItems: 'flex-start',
//   },
//   wineName: {
//     fontSize: 11,
//     color: '#7d0a0a',
//     marginBottom: 5,
//     fontWeight: 'bold',
//     maxWidth: 422,
//   },
//   wineAddress: {
//     maxWidth: 420,
//     fontSize: 10,
//     color: '#5f5f5f',
//     marginBottom: 8,
//     fontWeight: 'bold', 
//   },
//   wineDescription: {
//     flex: 1,
//     // maxWidth: 430, 
//     fontSize: 7.7,
//     color: '#000000',
//     marginBottom: 5,
//     // textAlign: 'justify',
//     lineHeight: 1.3,
    
//   },

//   winePrice: {
//     fontSize: 12,
//     // marginLeft: -13,
//     marginTop: 20,
//     fontWeight: "bold",
//     // textAlign: "right", 
//     color: "#8B2434",
//   },
//   winePrice1: {
//     fontSize: 12,
//     marginTop: 6,
//     // marginLeft: -13,
//     fontWeight: "bold",
//     // textAlign: "right",
//     color: "#8B2434", 
//   },
//   noWinesContainer: {
//     marginTop: 20,
//     textAlign: "center",
//   },
//   noWinesText: {
//     fontSize: 16,
//     fontWeight: "bold",
//     color: "red",
//   },
//   footer: {
//     position: 'absolute',
//     bottom: 0,
//     left: 0,
//     fontSize: 12,
//     fontWeight: 'bold',
//     width: "100%",
//     height: "12px",
//     backgroundColor: "#8B2434"
//   },
//   // pageContent: {
//   //   flex: 1,
//   //   marginBottom: 20,
//   //   // marginLeft:10,
//   //   // marginRight: 10,
//   //   marginTop: 25,
//   // },
//   pageContent: {
//     flex: 1,
//     // marginBottom: 20,
//     marginBottom: 10,
//     // marginLeft:10,
//     // marginRight: 10,
//     marginTop: 25,
//   },
//   fullWidthContent: {
//     // marginLeft: -20,
//     // marginRight: -20,
//     // paddingHorizontal: 20,
//   },
//   descriptionImage: {
//     // width: 70,
//     height: 70,
//     marginTop: 10,
//     alignSelf: 'flex-start',
//   },
// });

// const WinePDF = () => {
//   const { wine_list_name } = useParams();
//   const [searchParams] = useSearchParams();
//   const [restData, setRestData] = useState(null);
//   const criteria = searchParams.get('criteria');
//   const [imageLoaded, setImageLoaded] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [isDownloading, setIsDownloading] = useState(false);

//   const token = localStorage.getItem("token");
//   const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
//   const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

//   useEffect(() => {
//     setLoading(true);
//     if (criteria === "nation") {
//       axios
//         .get(`${apiUrl}/api/v1/wineList-pdf/${wine_list_name}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then(async (res) => {
//           if (res.status === 200) {
//             setRestData(res?.data);

//             const wineImages = [];
//             const data = res?.data?.data || {};

//             Object.entries(data).forEach(([nation, regions]) => {
//               Object.entries(regions).forEach(([region, wines]) => {
//                 wines.forEach(wine => {
//                   if (wine?.id && wine?.image) {
//                     wineImages.push({
//                       id: wine.id,
//                       url: wine.image
//                     });
//                   }
//                 });
//               });
//             });

//             if (wineImages.length === 0) {
//               setLoading(false);
//               return;
//             }

//             const imagePromises = wineImages.map((wineImage) =>
//               axios
//                 .get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(wineImage.url)}`, {
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                   },
//                   responseType: "blob",
//                 })
//                 .then((res) => {
//                   if (res.status === 200) {
//                     const imageBlobUrl = URL.createObjectURL(res.data);
//                     setImageLoaded((prev) => ({
//                       ...prev,
//                       [wineImage.id]: imageBlobUrl
//                     }));
//                     return true;
//                   }
//                   return false;
//                 })
//                 .catch(() => false)
//             );

//             await Promise.all(imagePromises);
//           }
//         })
//         .catch(() => setRestData(null))
//         .finally(() => setLoading(false));
//     } else {
//       axios
//         .get(`${apiUrl}/api/v1/wine-list/${wine_list_name}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then(async (res) => {
//           if (res.status === 200) {
//             setRestData(res?.data);

//             const wineImages = res?.data?.wines
//               ?.map((item) => ({
//                 id: item?.wine?.id,
//                 url: item?.wine?.image
//               }))
//               .filter(item => item.url);

//             if (wineImages.length === 0) {
//               setLoading(false);
//               return;
//             }

//             const imagePromises = wineImages.map((wineImage) =>
//               axios
//                 .get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(wineImage.url)}`, {
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                   },
//                   responseType: "blob",
//                 })
//                 .then((res) => {
//                   if (res.status === 200) {
//                     const imageBlobUrl = URL.createObjectURL(res.data);
//                     setImageLoaded((prev) => ({
//                       ...prev,
//                       [wineImage.id]: imageBlobUrl
//                     }));
//                     return true;
//                   }
//                   return false;
//                 })
//                 .catch(() => false)
//             );

//             await Promise.all(imagePromises);
//           }
//         })
//         .catch(() => setRestData(null))
//         .finally(() => setLoading(false));
//     }

//   }, [wine_list_name, criteria]);


//   const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
//   const logo = restData?.wineList?.restaurant?.logo ?
//     `${logoUrl}/${restData?.wineList?.restaurant?.logo}` : null;

//   // const stripHtmlTags = (html) => {
//   //   const tempDiv = document.createElement('div');
//   //   tempDiv.innerHTML = html;
//   //   return tempDiv.textContent || tempDiv.innerText || '';
//   // };

//   const stripHtmlTagsOld = (html, maxLength) => {
//     if (!html) return "";

//     // Strip HTML tags
//     const strippedText = new DOMParser()
//       .parseFromString(html, 'text/html')
//       .body.textContent || "";

//     // Return truncated text if maxLength is specified
//     return typeof maxLength === 'number'
//       ? strippedText.length > maxLength
//         ? strippedText.substring(0, maxLength - 3) + "..."
//         : strippedText
//       : strippedText;
//   };

//   const stripHtmlTags = (html, maxLength) => {
//     if (!html) return "";

//     // const withNewlines = html.replace(/<br\s*\/?>/gi, '\n');
//     const withNewlines = html.replace(/\s*<br\s*\/?>\s*/gi, '\n');


//     const strippedText = new DOMParser()
//       .parseFromString(withNewlines, 'text/html')
//       .body.textContent || "";

//     if (typeof maxLength === 'number') {
//       return strippedText.length > maxLength
//         ? strippedText.substring(0, maxLength - 3) + "..."
//         : strippedText;
//     }

//     return strippedText;
//   };

//   const truncateText = (text, maxLength) => {
//     if (!text) return "";
//     return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
//   };

//   const handleMobileDownload = async () => {
//     try {
//       setIsDownloading(true);
//       const { pdf } = await import('@react-pdf/renderer');
//       const blob = await pdf(
//         <Document>
//           {renderPages()}
//         </Document>
//       ).toBlob();

//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `wine-list-${new Date().toISOString().slice(0, 10)}.pdf`;
//       document.body.appendChild(link);
//       link.click();

//       // Show success toast
//       toast.success('Wine list successfully downloaded', {
//         position: "top-center",
//         autoClose: 1000,
//         theme: 'colored',
//       });

//       setTimeout(() => {
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//         setIsDownloading(false);
//       }, 100);
//     } catch (error) {
//       console.error('Error downloading PDF:', error);
//       setIsDownloading(false);

//       // Show error toast
//       toast.error('Failed to download wine list', {
//         position: "top-center",
//         autoClose: 2000,
//         theme: 'colored'
//       });
//     }
//   };

//   const renderWineCard = (item) => {

//     // const extractImageUrl = (html) => {
//     //   if (!html) return null;
//     //   const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/;
//     //   const match = html.match(imgRegex);
//     //   if (!match) return null;

//     //   const fullTag = match[0];
//     //   return {
//     //     src: match[1],
//     //     width: fullTag.match(/width="([^"]*)"/)?.[1] || '70',
//     //     height: fullTag.match(/height="([^"]*)"/)?.[1] || '70',
//     //     alt: fullTag.match(/alt="([^"]*)"/)?.[1] || '',
//     //     title: fullTag.match(/title="([^"]*)"/)?.[1] || ''
//     //   };
//     // };

//     // const descriptionImageUrl = extractImageUrl(item?.wine?.short_description);
//     const descriptionText = stripHtmlTags(item?.wine?.short_description || "", 500);

//     return (
//       <View style={[styles.wineCard, styles.fullWidthContent]} key={item?.wine?.id}>
//         <View style={styles.mainimg}>
//           {item?.wine?.image && imageLoaded[item?.wine?.id] ? (
//             <Image
//               source={{ uri: imageLoaded[item?.wine?.id] }}
//               style={styles.image}
//             />
//           ) : (
//             <Image source={bottle} style={styles.image} />
//           )}
//         </View>

//         <View style={styles.wineDetails}>
//           {/* <Text style={styles.wineName}>{item?.wine?.name || ""}</Text> */}
//           <Text style={styles.wineName}>{truncateText((item?.wine?.name || ""), 150)}</Text>
//           <Text style={styles.wineAddress}>
//             {item?.wine?.region && <Text style={{ fontWeight: 'bold' }}>Region: </Text>}{item?.wine?.region}
//             {item?.wine?.region && item?.wine?.nation ? ", " : ""}
//             {item?.wine?.nation && <Text style={{ fontWeight: 'bold' }}>Nation: </Text>} {item?.wine?.nation}
//             {(item?.wine?.region || item?.wine?.nation) && item?.wine?.grape_variety ? ", " : ""}
//             {item?.wine?.grape_variety && <Text style={{ fontWeight: 'bold' }}>Grape Variety: </Text>} {item?.wine?.grape_variety}
//           </Text>
//           {/* <Text style={styles.wineDescription}>
//             {stripHtmlTags((item?.wine?.short_description || ""), 500)}
//           </Text> */}
//           {/* Description text */}
//           <Text style={styles.wineDescription}>
//             {descriptionText}
//           </Text>

//           {/* Show the description image below text if it wasn't used as the main image */}
//           {/* {descriptionImageUrl && imageLoaded[item?.wine?.id] && (
//             <>
//               {console.log(descriptionImageUrl, "descriptionImageUrl")}
//               <Image
//                 src={{
//                   uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(descriptionImageUrl.src)}`,
//                   method: "GET",
//                   headers: { Authorization: `Bearer ${token}` },
//                 }}
//                 // style={styles.descriptionImage}
//                 style={[
//                   styles.descriptionImage,
//                   {
//                     width: parseInt(descriptionImageUrl.width),
//                     height: parseInt(descriptionImageUrl.height)
//                   }
//                 ]}
//               />
//             </>
//           )} */}
//         </View>

//         <View style={{ minWidth: "60px", width:'auto', gap: 5, marginLeft:'auto', textAlign:'left', }}>
//           {item?.pivot?.is_show_bottle_price && (
//             <Text style={styles.winePrice}>
//               <Image source={bottle} style={{ width: 10, height: 10 }} />
//               {" € " + item?.pivot?.bottle_price}
//             </Text>
//           )}
//           {item?.pivot?.is_show_glass_price && (
//             <Text style={styles.winePrice1}>
//               <Image source={glass} style={{ width: 10, height: 10 }} />
//               {" € " + item?.pivot?.glass_price}
//             </Text>
//           )}
//         </View>
//       </View>
//     );
//   };

//   const renderWineCardNation = (item) => {
//     // Extract image URL from description
//     // const extractImageUrl = (html) => {
//     //   if (!html) return null;
//     //   const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/;
//     //   const match = html.match(imgRegex);
//     //   return match ? match[1] : null;
//     // };

//     // const extractImageUrl = (html) => {
//     //   if (!html) return null;
//     //   const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/;
//     //   const match = html.match(imgRegex);
//     //   if (!match) return null;

//     //   const fullTag = match[0];
//     //   return {
//     //     src: match[1],
//     //     width: fullTag.match(/width="([^"]*)"/)?.[1] || '70',
//     //     height: fullTag.match(/height="([^"]*)"/)?.[1] || '70',
//     //     alt: fullTag.match(/alt="([^"]*)"/)?.[1] || '',
//     //     title: fullTag.match(/title="([^"]*)"/)?.[1] || ''
//     //   };
//     // };

//     // Get image URL from description if exists
//     // const descriptionImageUrl = extractImageUrl(item?.short_description);
//     const descriptionText = stripHtmlTags(item?.short_description || "", 500);
//     // console.log(item?.long_description)

//     return (
//       <View style={[styles.wineCard, styles.fullWidthContent]} key={item?.id}>
//         <View style={styles.mainimg}>
//           {item?.image && imageLoaded[item?.id] ? (
//             <Image
//               source={{ uri: imageLoaded[item?.id] }}
//               style={styles.image}
//             />
//           ) : (
//             <Image source={bottle} style={styles.image} />
//           )}
//         </View>

//         <View style={styles.wineDetails}>
//           <Text style={styles.wineName}>{truncateText(item?.name || "", 150)}</Text>
//           <Text style={styles.wineAddress}>
//             {item?.region && <Text style={{ fontWeight: 'bold' }}>Region: </Text>}{item?.region}
//             {item?.region && item?.nation ? ", " : ""}
//             {item?.nation && <Text style={{ fontWeight: 'bold' }}>Nation: </Text>} {item?.nation}
//             {(item?.region || item?.nation) && item?.grape_variety ? ", " : ""}
//             {item?.grape_variety && <Text style={{ fontWeight: 'bold' }}>Grape Variety: </Text>} {item?.grape_variety}
//           </Text>

//           {/* Description text */}
//           <Text style={styles.wineDescription}>
//             {descriptionText}
//           </Text>

//           {/* {descriptionImageUrl && imageLoaded[item?.id] && (
//             <>
//               {console.log(descriptionImageUrl, "descriptionImageUrl")}
//               <Image
//                 src={{
//                   uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(descriptionImageUrl.src)}`,
//                   method: "GET",
//                   headers: { Authorization: `Bearer ${token}` },
//                 }}
//                 // style={styles.descriptionImage}
//                 style={[
//                   styles.descriptionImage,
//                   {
//                     width: parseInt(descriptionImageUrl.width),
//                     height: parseInt(descriptionImageUrl.height)
//                   }
//                 ]}
//               />
//             </>
//           )} */}
//         </View>

//         <View style={{ minWidth: "60px", width:'auto', gap: 5, marginLeft:'auto', textAlign:'left', }}>
//           {item?.pivot?.is_show_bottle_price && (
//             <Text style={styles.winePrice}>
//               <Image source={bottle} style={{ width: 10, height: 10 }} />
//               {" € " + item?.pivot?.bottle_price}
//             </Text>
//           )}
//           {item?.pivot?.is_show_glass_price && (
//             <Text style={styles.winePrice1}>
//               <Image source={glass} style={{ width: 10, height: 10 }} />
//               {" € " + item?.pivot?.glass_price}
//             </Text>
//           )}
//         </View>
//       </View>
//     );
//   };

//   const renderPages = () => {
//     if (criteria === "product_type") {
//       if (!restData?.wines?.length) {
//         return (
//           <Page size="A4" style={styles.page}>
//             <Image style={styles.backgroundImage} src={BannerImg} fixed />
//             {logo && (
//               <Image
//                 src={{
//                   uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
//                   method: "GET",
//                   headers: { Authorization: `Bearer ${token}` },
//                 }}
//                 style={styles.LogoImage}
//               />
//             )}
//             <Image style={styles.LogoImage1} src={img} fixed />
//             <Text style={styles.footer} fixed />
//             <Text style={styles.WineListName}>{""}</Text>
//             <View style={styles.noWinesContainer}>
//               <Text style={styles.noWinesText}>No wines found.</Text>
//             </View>
//           </Page>
//         );
//       }
//     } else {
//       if (!restData?.data) {
//         return (
//           <Page size="A4" style={styles.page}>
//             <Image style={styles.backgroundImage} src={BannerImg} fixed />
//             {logo && (
//               <Image
//                 src={{
//                   uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
//                   method: "GET",
//                   headers: { Authorization: `Bearer ${token}` },
//                 }}
//                 style={styles.LogoImage}
//               />
//             )}
//             <Image style={styles.LogoImage1} src={img} fixed />
//             <Text style={styles.footer} fixed />
//             <Text style={styles.WineListName}>{""}</Text>
//             <View style={styles.noWinesContainer}>
//               <Text style={styles.noWinesText}>No wines found.</Text>
//             </View>
//           </Page>
//         );
//       }
//     }

//     const pages = [];
//     let currentPageContent = [];
//     let currentWineCount = 0;

//     if (criteria === "nation") {
//       Object.entries(restData.data).forEach(([nation, regions]) => {
//         // Nation Header
//         if (currentWineCount > 0 && currentWineCount + 1 > 4) {
//           pages.push(currentPageContent);
//           currentPageContent = [];
//           currentWineCount = 0;
//         }

//         currentPageContent.push(
//           <View key={`nation-${nation}`} style={styles.WineBorder}>
//             <Text style={styles.wineType}>{nation}</Text>
//           </View>
//         );

//         Object.entries(regions).forEach(([region, wines]) => {
//           // Region Header
//           if (wines.length > 0) {
//             if (currentWineCount > 0 && currentWineCount + 1 > 4) {
//               pages.push(currentPageContent);
//               currentPageContent = [
//                 <View key={`nation-continued-${nation}`} style={styles.WineBorder}>
//                   <Text style={styles.wineType}>{nation}</Text>
//                 </View>
//               ];
//               currentWineCount = 0;
//             }

//             currentPageContent.push(
//               <View key={`region-${region}`}>
//                 <Text style={styles.regionType}>{region}</Text>
//               </View>
//             );
//           }

//           wines.forEach((wine) => {
//             if (currentWineCount >= 4) {
//               pages.push(currentPageContent);
//               currentPageContent = [
//                 <View key={`nation-continued-${nation}`} style={styles.WineBorder}>
//                   <Text style={styles.wineType}>{nation}</Text>
//                 </View>,
//                 <View key={`region-continued-${region}`}>
//                   <Text style={styles.regionType}>{region}</Text>
//                 </View>
//               ];
//               currentWineCount = 0;
//             }

//             currentPageContent.push(renderWineCardNation(wine));
//             currentWineCount++;
//           });
//         });
//       });
//     } else if (criteria === "product_type") {
//       const wineTypes = [...new Set(restData?.wines?.map((wine) => wine?.wine?.[criteria]))]
//         .filter(type => type)
//         .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

//       wineTypes.forEach((type) => {
//         const typeData = restData?.wines?.filter((wine) => wine?.wine?.[criteria] === type);

//         // Add type header
//         if (currentWineCount > 0) {
//           // If adding this type would exceed 4 wines per page, start new page
//           if (currentWineCount + 1 > 4) {
//             pages.push(currentPageContent);
//             currentPageContent = [];
//             currentWineCount = 0;
//           }
//         }

//         currentPageContent.push(
//           <View key={`type-${type}`} style={styles.WineBorder}>
//             <Text style={styles.wineType}>{type || ""}</Text>
//           </View>
//         );

//         typeData.forEach((item) => {
//           if (currentWineCount >= 4) {
//             pages.push(currentPageContent);
//             currentPageContent = [
//               // <View key={`type-continued-${type}`} style={styles.WineBorder}>
//               //   <Text style={styles.wineType}>{type || ""}</Text>
//               // </View>
//             ];
//             currentWineCount = 0;
//           }

//           currentPageContent.push(renderWineCard(item));
//           currentWineCount++;
//         });
//       });
//     }

//     // Push the last page
//     if (currentPageContent.length > 0) {
//       pages.push(currentPageContent);
//     }

//     return pages.map((pageContent, index) => (
//       <Page key={`page-${index}`} size="A4" style={styles.page}>
//         <Image style={styles.backgroundImage} src={BannerImg} fixed />
//         {logo && index === 0 && (
//           <Image
//             src={{
//               uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
//               method: "GET",
//               headers: { Authorization: `Bearer ${token}` },
//             }}
//             style={styles.LogoImage}
//           />
//         )}
//         <Image style={styles.LogoImage1} src={img} fixed />
//         {/* {index === 0 && <Image style={styles.LogoImage} src={img} fixed />} */}
//         {/* {index === 0 && <Text style={styles.WineListName}>{restData?.wineList?.name || ""}</Text>} */}

//         {index === 0 && <Text style={styles.WineListName}>
//           {truncateText((restData?.wineList?.name || ""), 60)}
//         </Text>}

//         {index === 0 && restData?.wineList?.is_show_sentence && (
//           <Text style={styles.WineListDescription}>
//             {/* {(restData?.wineList?.description || "").replace(/[\r\n]+/g, " ")} */}
//             {truncateText((restData?.wineList?.description || "").replace(/[\r\n]+/g, " "), 200)}
//           </Text>
//         )}

//         {/* {index === 0 && restData?.wineList?.is_show_sentence && <Text style={styles.WineListDescription}>{restData?.wineList?.description || ""}</Text>} */}
//         <View style={styles.pageContent}>
//           {pageContent}
//         </View>
//         <Text style={styles.footer} fixed />
//       </Page>
//     ));
//   };


//   if (loading) {
//     return <div className="flex justify-center items-center h-screen">
//       <svg
//         aria-hidden="true"
//         className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
//         viewBox="0 0 100 101"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//           fill="currentColor"
//         />
//         <path
//           d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//           fill="currentFill"
//         />
//       </svg>
//       <span className="sr-only">Loading...</span>
//     </div>
//   }


//   if (isMobile) {
//     return (
//       <div className="flex flex-col items-center justify-center h-screen p-4">
//         <div className="text-center">

//           <button
//             onClick={handleMobileDownload}
//             disabled={isDownloading}
//             className="px-4 py-2 bg-[#8A2533] text-white rounded-md flex items-center justify-center"
//           >
//             {isDownloading ? (
//               <>
//                 <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                 </svg>
//                 Downloading...
//               </>
//             ) : (
//               'Download PDF'
//             )}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <PDFViewer style={{ width: '100%', height: '100vh' }}>
//       <Document>
//         {renderPages()}
//       </Document>
//     </PDFViewer>
//   );
// };

// export default WinePDF;







import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { PDFViewer, Document, Page, Text, View, Image, StyleSheet, Font } from '@react-pdf/renderer';
import img from '../../../assets/restaurant/meteri-logo.png'
import BannerImg from '../../../assets/restaurant/BannerBg.png'
import bottle from '../../../assets/pdf/wine-bottle.png'
import glass from '../../../assets/pdf/wine.png'

import FontBoldWoff from '../../../assets/font/Montserrat-Bold.woff';
import FontBoldWoff2 from '../../../assets/font/Montserrat-Bold.woff2';

import FontBoldWoff3 from '../../../assets/font/MontserratAlternates-MediumItalic.woff';
import FontBoldWoff4 from '../../../assets/font/MontserratAlternates-MediumItalic.woff2';

import { toast } from "react-toastify";

// Soft break words longer
Font.registerHyphenationCallback((word) => {
    if (word.length > 15) {
        return word.match(/.{1,10}/g);
    }
    return [word];
});


Font.register({
    family: 'Montserrat',
    fonts: [
        {
            src: FontBoldWoff,
            fontWeight: 'bold',
        },
        {
            src: FontBoldWoff2,
            fontWeight: 'bold',
        },
        {
            src: FontBoldWoff3,
            fontWeight: 100,
        },
        {
            src: FontBoldWoff4,
            fontWeight: 100,
        },
    ],
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 20,
        fontSize: 12,
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundSize: 'cover',
        backgroundPosition: 'left center',
        zIndex: -1,
        opacity: 0.3,
    },
    WineBorder: {
        borderTop: '1px solid #d8b6ba',
        marginBottom: 5,
        marginTop: 10,
        marginLeft: -20,
        marginRight: -20,
        paddingHorizontal: 20,
    },
    WineListName: {
        maxWidth: '310px',
        // margin: '0 auto',
        margin: '20px auto 10px',
        fontSize: 18,
        textAlign: 'left',
        color: '#7d0a0a',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
        textTransform: 'capitalize',
        wordWrap: 'break-word',
        overflow: 'hidden',
        maxHeight: '70px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    WineListDescription: {
        maxWidth: "480px",
        width: "100%",
        fontSize: 11,
        textAlign: "center",
        color: "#7d0a0a",
        fontWeight: 100,
        fontFamily: "Montserrat",
        textTransform: "capitalize",
        wordWrap: "break-word",
        overflow: "hidden",
        lineHeight: "13px",
        margin: "auto",
        marginBottom: -20,
    },
    wineType: {
        fontSize: 18,
        color: '#5f5f5f',
        fontWeight: 'bold',
        // marginBottom: 10,
        marginTop: 5,
        marginLeft: 20,
    },
    regionType: {
        fontSize: 15,
        color: '#5f5f5f',
        fontWeight: 'bold',
        // marginBottom: 5,
        textAlign: 'left',
        marginLeft: 20,
    },
    wineCard: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        // marginBottom: 20,
        paddingBottom: 15,
        paddingTop: 5,
        gap: 10,
        // borderBottom: '1px solid #f0f0f0',
        pageBreakInside: 'avoid',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    mainimg: {
        width: 30,
        height: 115,
        marginRight: 5,
    },
    LogoImage: {
        width: 105,
        height: 50,
        objectFit: 'contain',
        position: 'absolute',
        top: 12,
        left: 8, // Match content padding
        zIndex: 10
    },
    LogoImage1: {
        width: 105,
        height: 50,
        objectFit: 'contain',
        position: 'absolute',
        top: 12,
        right: 10,
        zIndex: 10
    },
    wineDetails: {
        flex: 1,
        paddingTop: 10,
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    wineName: {
        fontSize: 11,
        color: '#7d0a0a',
        marginBottom: 5,
        fontWeight: 'bold',
        maxWidth: 422,
    },
    mainTitleContainer: {
        fontSize: 20,
        color: '#7d0a0a',
        // marginBottom: 5,
        fontWeight: 'bold',
        // maxWidth: 422,
        marginTop: 5,
        marginLeft: 20
    },
    sectionHeader: {
        fontSize: 15,
        color: '#7d0a0a',
        // marginBottom: 5,
        fontWeight: 'bold',
        // maxWidth: 422,
    },
    wineAddress: {
        maxWidth: 420,
        fontSize: 10,
        color: '#5f5f5f',
        marginBottom: 8,
        fontWeight: 'bold',
    },
    wineDescription: {
        flex: 1,
        // maxWidth: 430, 
        fontSize: 7.7,
        color: '#000000',
        marginBottom: 5,
        // textAlign: 'justify',
        lineHeight: 1.3,

    },
    winePrice: {
        fontSize: 12,
        // marginLeft: -13,
        marginTop: 20,
        fontWeight: "bold",
        // textAlign: "right", 
        color: "#8B2434",
    },
    winePrice1: {
        fontSize: 12,
        marginTop: 6,
        // marginLeft: -13,
        fontWeight: "bold",
        // textAlign: "right",
        color: "#8B2434",
    },
    noWinesContainer: {
        marginTop: 20,
        textAlign: "center",
    },
    noWinesText: {
        fontSize: 16,
        fontWeight: "bold",
        color: "red",
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        fontSize: 12,
        fontWeight: 'bold',
        width: "100%",
        height: "12px",
        backgroundColor: "#8B2434"
    },
    // pageContent: {
    //   flex: 1,
    //   marginBottom: 20,
    //   // marginLeft:10,
    //   // marginRight: 10,
    //   marginTop: 25,
    // },
    pageContent: {
        flex: 1,
        // marginBottom: 20,
        marginBottom: 10,
        // marginLeft:10,
        // marginRight: 10,
        marginTop: 25,
    },
    fullWidthContent: {
        // marginLeft: -20,
        // marginRight: -20,
        // paddingHorizontal: 20,
    },
    descriptionImage: {
        // width: 70,
        height: 70,
        marginTop: 10,
        alignSelf: 'flex-start',
    },
});

const WinePDF = () => {
    const { wine_list_name } = useParams();
    const [searchParams] = useSearchParams();
    const [restData, setRestData] = useState(null);
    const criteria = searchParams.get('criteria');
    const [imageLoaded, setImageLoaded] = useState({});
    const [loading, setLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);

    const token = localStorage.getItem("token");
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    useEffect(() => {
        setLoading(true);
        if (criteria === "nation") {
            axios
                .get(`${apiUrl}/api/v1/wineList-pdf/${wine_list_name}`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then(async (res) => {
                    if (res.status === 200) {
                        setRestData(res?.data);

                        const wineImages = [];
                        const data = {
                            ...res?.data?.restaurantWinesGrouped,
                            ...res?.data?.meteriWinesGrouped
                        };

                        // Process both data structures
                        Object.entries(data).forEach(([nation, regionsOrWines]) => {
                            if (Array.isArray(regionsOrWines)) {
                                // Handle meteri wines (direct array)
                                regionsOrWines.forEach(wine => {
                                    if (wine?.id && wine?.image) {
                                        wineImages.push({
                                            id: wine.id,
                                            url: wine.image,
                                            wines_from: wine.wines_from || 'meteri'
                                        });
                                    }
                                });
                            } else {
                                // Handle restaurant wines (grouped by region)
                                Object.values(regionsOrWines).forEach(wines => {
                                    wines.forEach(wine => {
                                        if (wine?.id && wine?.image) {
                                            wineImages.push({
                                                id: wine.id,
                                                url: wine.image,
                                                wines_from: wine.wines_from || 'restaurant'
                                            });
                                        }
                                    });
                                });
                            }
                        });

                        if (wineImages.length === 0) {
                            setLoading(false);
                            return;
                        }

                        // Process all images through proxy endpoint
                        const imagePromises = wineImages.map((wineImage) => {
                            // Construct the appropriate full URL based on source
                            const fullImageUrl = wineImage.wines_from === 'restaurant'
                                ? `${logoUrl}/${wineImage.url}`
                                : wineImage.url;

                            // Pass the complete URL through the proxy
                            return axios
                                .get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(fullImageUrl)}`, {
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                    },
                                    responseType: "blob",
                                })
                                .then((res) => {
                                    const imageBlobUrl = URL.createObjectURL(res.data);
                                    setImageLoaded((prev) => ({
                                        ...prev,
                                        [wineImage.id]: imageBlobUrl
                                    }));
                                    return true;
                                })
                                .catch((error) => {
                                    console.error(`Failed to load wine image for ${wineImage.id}:`, error);
                                    // Set fallback image
                                    setImageLoaded((prev) => ({
                                        ...prev,
                                        [wineImage.id]: '/images/wine-placeholder.jpg'
                                    }));
                                    return false;
                                });
                        });

                        await Promise.all(imagePromises);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching wine list:", error);
                    setRestData(null);
                })
                .finally(() => setLoading(false));
        } else {
            axios
                .get(`${apiUrl}/api/v1/wine-list-by-product/${wine_list_name}`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then(async (res) => {
                    if (res.status === 200) {
                        setRestData(res?.data);

                        // Collect all wine images from both meteri and restaurant wines
                        const wineImages = [];

                        // Process meteri wines
                        if (res.data?.meteriWines) {
                            Object.values(res.data.meteriWines).forEach(wines => {
                                wines.forEach(wine => {
                                    if (wine?.wine?.id && wine?.wine?.image) {
                                        wineImages.push({
                                            id: wine.wine.id,
                                            url: wine.wine.image,
                                            isRestaurant: false
                                        });
                                    }
                                });
                            });
                        }

                        // Process restaurant wines
                        if (res.data?.restaurantWines) {
                            Object.values(res.data.restaurantWines).forEach(wines => {
                                wines.forEach(wine => {
                                    if (wine?.wine?.id && wine?.wine?.image) {
                                        wineImages.push({
                                            id: wine.wine.id,
                                            url: wine.wine.image,
                                            isRestaurant: true
                                        });
                                    }
                                });
                            });
                        }

                        if (wineImages.length === 0) {
                            setLoading(false);
                            return;
                        }

                        const imagePromises = wineImages.map((wineImage) => {
                            const imageUrl = wineImage.isRestaurant
                                ? `${logoUrl}/${wineImage.url}`
                                : wineImage.url;

                            return axios
                                .get(`${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(imageUrl)}`, {
                                    headers: { Authorization: `Bearer ${token}` },
                                    responseType: "blob",
                                })
                                .then((res) => {
                                    if (res.status === 200) {
                                        const imageBlobUrl = URL.createObjectURL(res.data);
                                        setImageLoaded(prev => ({ ...prev, [wineImage.id]: imageBlobUrl }));
                                        return true;
                                    }
                                    return false;
                                })
                                .catch(() => false);
                        });

                        await Promise.all(imagePromises);
                    }
                })
                .catch(() => setRestData(null))
                .finally(() => setLoading(false));
        }

    }, [wine_list_name, criteria, apiUrl, token]);


    const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;
    const logo = restData?.wineList?.restaurant?.logo ?
        `${logoUrl}/${restData?.wineList?.restaurant?.logo}` : null;


    const stripHtmlTags = (html, maxLength) => {
        if (!html) return "";

        // const withNewlines = html.replace(/<br\s*\/?>/gi, '\n');
        const withNewlines = html.replace(/\s*<br\s*\/?>\s*/gi, '\n');


        const strippedText = new DOMParser()
            .parseFromString(withNewlines, 'text/html')
            .body.textContent || "";

        if (typeof maxLength === 'number') {
            return strippedText.length > maxLength
                ? strippedText.substring(0, maxLength - 3) + "..."
                : strippedText;
        }

        return strippedText;
    };

    const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
    };

    const handleMobileDownload = async () => {
        try {
            setIsDownloading(true);
            const { pdf } = await import('@react-pdf/renderer');
            const blob = await pdf(
                <Document>
                    {renderPages()}
                </Document>
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `wine-list-${new Date().toISOString().slice(0, 10)}.pdf`;
            document.body.appendChild(link);
            link.click();

            // Show success toast
            toast.success('Wine list successfully downloaded', {
                position: "top-center",
                autoClose: 1000,
                theme: 'colored',
            });

            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                setIsDownloading(false);
            }, 100);
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setIsDownloading(false);

            // Show error toast
            toast.error('Failed to download wine list', {
                position: "top-center",
                autoClose: 2000,
                theme: 'colored'
            });
        }
    };

    const renderWineCard = (item) => {
        const descriptionText = stripHtmlTags(item?.wine?.short_description || "", 500);

        return (
            <View style={[styles.wineCard, styles.fullWidthContent]} key={item?.wine?.id}>
                <View style={styles.mainimg}>
                    {item?.wine?.image && imageLoaded[item?.wine?.id] && (
                        <Image
                            source={{ uri: imageLoaded[item?.wine?.id] }}
                            style={styles.image}
                        />
                    )}

                </View>
                <View style={styles.wineDetails}>
                    <Text style={styles.wineName}>{truncateText((item?.wine?.name || ""), 150)}</Text>
                    <Text style={styles.wineAddress}>
                        {item?.wine?.region && `${item.wine.region}`}
                        {item?.wine?.region && item?.wine?.nation ? ', ' : ''}
                        {item?.wine?.nation && `${item.wine.nation}`}
                        {(item?.wine?.region || item?.wine?.nation) && item?.wine?.grape_variety ? ', ' : ''}
                        {item?.wine?.grape_variety && `${item.wine.grape_variety}`}
                    </Text>
                    <Text style={styles.wineDescription}>
                        {descriptionText}
                    </Text>
                </View>

                <View style={{ minWidth: "60px", width: 'auto', gap: 5, marginLeft: 'auto', textAlign: 'left', }}>
                    {item?.pivot?.is_show_bottle_price && (
                        <Text style={styles.winePrice}>
                            <Image source={bottle} style={{ width: 10, height: 10 }} />
                            {" € " + item?.pivot?.bottle_price}
                        </Text>
                    )}
                    {item?.pivot?.is_show_glass_price && (
                        <Text style={styles.winePrice1}>
                            <Image source={glass} style={{ width: 10, height: 10 }} />
                            {" € " + item?.pivot?.glass_price}
                        </Text>
                    )}
                </View>
            </View>
        );
    };

    const renderWineCardNation = (item) => {
        const descriptionText = stripHtmlTags(item?.short_description || "", 500);

        return (
            <View style={[styles.wineCard, styles.fullWidthContent]} key={item?.id}>
                <View style={styles.mainimg}>
                    {["restaurant", "meteri"].includes(item.wines_from) && item?.image && (
                        <Image
                            source={{
                                uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(
                                    item.wines_from === "restaurant"
                                        ? `${logoUrl}/${item.image}`
                                        : item.image
                                )}`,
                                method: "GET",
                                headers: { Authorization: `Bearer ${token}` },
                            }}
                            style={styles.image}
                        />
                    )}
                </View>
                <View style={styles.wineDetails}>
                    <Text style={styles.wineName}>{truncateText(item?.name || "", 150)}</Text>
                    <Text style={styles.wineAddress}>
                        {item?.region && `${item.region}`}
                        {item?.region && item?.nation ? ', ' : ''}
                        {item?.nation && `${item.nation}`}
                        {(item?.region || item?.nation) && item?.grape_variety ? ', ' : ''}
                        {item?.grape_variety && `${item.grape_variety}`}
                    </Text>

                    <Text style={styles.wineDescription}>
                        {descriptionText}
                    </Text>
                </View>

                <View style={{ minWidth: "60px", width: 'auto', gap: 5, marginLeft: 'auto', textAlign: 'left', }}>
                    {item?.pivot?.is_show_bottle_price && (
                        <Text style={styles.winePrice}>
                            <Image source={bottle} style={{ width: 10, height: 10 }} />
                            {" € " + item?.pivot?.bottle_price}
                        </Text>
                    )}
                    {item?.pivot?.is_show_glass_price && (
                        <Text style={styles.winePrice1}>
                            <Image source={glass} style={{ width: 10, height: 10 }} />
                            {" € " + item?.pivot?.glass_price}
                        </Text>
                    )}
                </View>
            </View>
        );
    };

    const renderPages = () => {

        if (!restData) {
            return (
                <Page size="A4" style={styles.page}>
                    <Image style={styles.backgroundImage} src={BannerImg} fixed />
                    {logo && (
                        <Image
                            src={{
                                uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
                                method: "GET",
                                headers: { Authorization: `Bearer ${token}` },
                            }}
                            style={styles.LogoImage}
                        />
                    )}
                    <Image style={styles.LogoImage1} src={img} fixed />
                    <Text style={styles.footer} fixed />
                    <Text style={styles.WineListName}>{""}</Text>
                    <View style={styles.noWinesContainer}>
                        <Text style={styles.noWinesText}>No wines found.</Text>
                    </View>
                </Page>
            );
        }

        const pages = [];
        let currentPageContent = [];
        let currentWineCount = 0;
        // console.log(criteria)

        if (criteria === "nation") {
            // Track if we've shown the main titles
            let meteriTitleShown = false;
            let restaurantTitleShown = false;

            // First process Meteri wines
            if (restData?.meteriWinesGrouped && Object.keys(restData.meteriWinesGrouped).length > 0) {
                // Process Meteri wines
                Object.entries(restData.meteriWinesGrouped).forEach(([nation, winesOrRegions], nationIndex) => {
                    const hasRegions = !Array.isArray(winesOrRegions);

                    // Nation Header with WineBorder
                    if (currentWineCount > 0 && currentWineCount + 1 > 4) {
                        pages.push(currentPageContent);
                        currentPageContent = [
                            // <View key="meteri-title-continued" style={styles.mainTitleContainer}>
                            //     <Text style={styles.mainTitle}>Selezione Meteri</Text>
                            // </View>
                        ];
                        currentWineCount = 0;
                        meteriTitleShown = false; // Reset for new page
                    }

                    currentPageContent.push(
                        <View key={`meteri-nation-${nation}`}>
                            <View style={styles.WineBorder}>
                                {/* {!meteriTitleShown && nationIndex === 0 && (
                                    <Text style={styles.mainTitleContainer}>Selezione Meteri</Text>
                                )} */}
                                <Text style={styles.wineType}>{nation}</Text>
                            </View>
                            {/* {!meteriTitleShown && nationIndex === 0 && (
                                <Text style={styles.mainTitleContainer}>Selezione Meteri</Text>
                            )} */}
                        </View>
                    );
                    meteriTitleShown = true;

                    // Rest of the Meteri processing remains the same...
                    if (hasRegions) {
                        Object.entries(winesOrRegions).forEach(([region, wines]) => {
                            if (wines.length > 0) {
                                if (currentWineCount > 0 && currentWineCount + 1 > 4) {
                                    pages.push(currentPageContent);
                                    currentPageContent = [
                                        // <View key="meteri-title-continued" style={styles.mainTitleContainer}>
                                        //     <Text style={styles.mainTitle}>Selezione Meteri</Text>
                                        // </View>,
                                        <View key={`meteri-nation-continued-${nation}`} style={styles.WineBorder}>
                                            <Text style={styles.wineType}>{nation}</Text>
                                        </View>
                                    ];
                                    currentWineCount = 0;
                                }

                                currentPageContent.push(
                                    <View key={`meteri-region-${region}`}>
                                        <Text style={styles.regionType}>{region}</Text>
                                    </View>
                                );

                                wines.forEach((wine) => {
                                    if (currentWineCount >= 4) {
                                        pages.push(currentPageContent);
                                        currentPageContent = [
                                            // <View key="meteri-title-continued" style={styles.mainTitleContainer}>
                                            //     <Text style={styles.mainTitle}>Selezione Meteri</Text>
                                            // </View>,
                                            <View key={`meteri-nation-continued-${nation}`} style={styles.WineBorder}>
                                                <Text style={styles.wineType}>{nation}</Text>
                                            </View>,
                                            <View key={`meteri-region-continued-${region}`}>
                                                <Text style={styles.regionType}>{region}</Text>
                                            </View>
                                        ];
                                        currentWineCount = 0;
                                    }
                                    currentPageContent.push(renderWineCardNation(wine));
                                    currentWineCount++;
                                });
                            }
                        });
                    } else {
                        // Process direct wines (no regions)
                        winesOrRegions.forEach((wine) => {
                            if (currentWineCount >= 4) {
                                pages.push(currentPageContent);
                                currentPageContent = [
                                    // <View key="meteri-title-continued" style={styles.mainTitleContainer}>
                                    //     <Text style={styles.mainTitle}>Selezione Meteri</Text>
                                    // </View>,
                                    <View key={`meteri-nation-continued-${nation}`} style={styles.WineBorder}>
                                        <Text style={styles.wineType}>{nation}</Text>
                                    </View>
                                ];
                                currentWineCount = 0;
                            }
                            currentPageContent.push(renderWineCardNation(wine));
                            currentWineCount++;
                        });
                    }
                });
            }

            if (restData?.restaurantWinesGrouped && Object.keys(restData.restaurantWinesGrouped).length > 0) {
                // Page break if both sections exist
                if (currentPageContent.length > 0) {
                    pages.push(currentPageContent);
                    currentPageContent = [];
                    currentWineCount = 0;
                    restaurantTitleShown = false;
                }

                const otherWinesTitle = "Altri Vini";

                // Process Restaurant wines
                Object.entries(restData.restaurantWinesGrouped).forEach(([nation, winesOrRegions], nationIndex) => {
                    const hasRegions = !Array.isArray(winesOrRegions);

                    // Nation Header with WineBorder
                    if (currentWineCount > 0 && currentWineCount + 1 > 4) {
                        pages.push(currentPageContent);
                        currentPageContent = [
                            // <View key="restaurant-title-continued" style={styles.mainTitleContainer}>
                            //     <Text style={styles.mainTitle}>{otherWinesTitle}</Text>
                            // </View>
                        ];
                        currentWineCount = 0;
                        restaurantTitleShown = false;
                    }

                    currentPageContent.push(
                        <View key={`restaurant-nation-${nation}`}>
                            <View style={styles.WineBorder}>
                                {/* {!restaurantTitleShown && nationIndex === 0 && (
                                    <Text style={styles.mainTitleContainer}>{otherWinesTitle}</Text>
                                )} */}
                                <Text style={styles.wineType}>{nation}</Text>
                            </View>
                            {/* {!restaurantTitleShown && nationIndex === 0 && (
                                <Text style={styles.mainTitleContainer}>{otherWinesTitle}</Text>
                            )} */}
                        </View>
                    );
                    restaurantTitleShown = true;

                    // Rest of the Restaurant processing remains the same...
                    if (hasRegions) {
                        Object.entries(winesOrRegions).forEach(([region, wines]) => {
                            if (wines.length > 0) {
                                if (currentWineCount > 0 && currentWineCount + 1 > 4) {
                                    pages.push(currentPageContent);
                                    currentPageContent = [
                                        // <View key="restaurant-title-continued" style={styles.mainTitleContainer}>
                                        //     <Text style={styles.mainTitle}>{otherWinesTitle}</Text>
                                        // </View>,
                                        <View key={`restaurant-nation-continued-${nation}`} style={styles.WineBorder}>
                                            <Text style={styles.wineType}>{nation}</Text>
                                        </View>
                                    ];
                                    currentWineCount = 0;
                                }

                                currentPageContent.push(
                                    <View key={`restaurant-region-${region}`}>
                                        <Text style={styles.regionType}>{region}</Text>
                                    </View>
                                );

                                wines.forEach((wine) => {
                                    if (currentWineCount >= 4) {
                                        pages.push(currentPageContent);
                                        currentPageContent = [
                                            // <View key="restaurant-title-continued" style={styles.mainTitleContainer}>
                                            //     <Text style={styles.mainTitle}>{otherWinesTitle}</Text>
                                            // </View>,
                                            <View key={`restaurant-nation-continued-${nation}`} style={styles.WineBorder}>
                                                <Text style={styles.wineType}>{nation}</Text>
                                            </View>,
                                            <View key={`restaurant-region-continued-${region}`}>
                                                <Text style={styles.regionType}>{region}</Text>
                                            </View>
                                        ];
                                        currentWineCount = 0;
                                    }
                                    currentPageContent.push(renderWineCardNation(wine));
                                    currentWineCount++;
                                });
                            }
                        });
                    } else {
                        // Process direct wines (no regions)
                        winesOrRegions.forEach((wine) => {
                            if (currentWineCount >= 4) {
                                pages.push(currentPageContent);
                                currentPageContent = [
                                    // <View key="restaurant-title-continued" style={styles.mainTitleContainer}>
                                    //     <Text style={styles.mainTitle}>{otherWinesTitle}</Text>
                                    // </View>,
                                    <View key={`restaurant-nation-continued-${nation}`} style={styles.WineBorder}>
                                        <Text style={styles.wineType}>{nation}</Text>
                                    </View>
                                ];
                                currentWineCount = 0;
                            }
                            currentPageContent.push(renderWineCardNation(wine));
                            currentWineCount++;
                        });
                    }
                });
            }
        } else if (criteria === "product_type") {
            // Track if we've shown the main titles
            let meteriTitleShown = false;
            let restaurantTitleShown = false;

            // Render METERI wines section
            if (restData.meteriWines && Object.keys(restData.meteriWines).length > 0) {
                // Process Meteri wines
                Object.entries(restData.meteriWines).forEach(([productType, wines], typeIndex) => {
                    // Check if we need a new page
                    if (currentWineCount > 0 && currentWineCount + 1 > 4) {
                        pages.push(currentPageContent);
                        currentPageContent = [];
                        currentWineCount = 0;
                        meteriTitleShown = false; // Reset for new page
                    }

                    // Add product type header with WineBorder
                    currentPageContent.push(
                        <View key={`meteri-type-${productType}`}>
                            <View style={styles.WineBorder}>
                                {/* {!meteriTitleShown && typeIndex === 0 && (
                                    <Text style={styles.mainTitleContainer}>Selezione Meteri</Text>
                                )} */}
                                <Text style={styles.wineType}>{productType}</Text>
                            </View>
                        </View>
                    );
                    meteriTitleShown = true;

                    // Add wines for this product type
                    wines.forEach(wine => {
                        if (currentWineCount >= 4) {
                            pages.push(currentPageContent);
                            currentPageContent = [
                                // <View key="meteri-header-continued" style={styles.sectionHeader}>
                                //     <Text style={styles.sectionTitle}>Selezione Meteri</Text>
                                // </View>,
                                <View key={`meteri-type-continued-${productType}`} style={styles.WineBorder}>
                                    <Text style={styles.wineType}>{productType}</Text>
                                </View>
                            ];
                            currentWineCount = 0;
                        }
                        currentPageContent.push(renderWineCard(wine));
                        currentWineCount++;
                    });
                });
            }

            // Render Restaurant wines section (Altri Vini)
            if (restData?.restaurantWines && Object.keys(restData.restaurantWines).length > 0) {
                // Add section break if needed
                if (currentPageContent.length > 0) {
                    pages.push(currentPageContent);
                    currentPageContent = [];
                    currentWineCount = 0;
                    restaurantTitleShown = false;
                }

                // Process Restaurant wines
                Object.entries(restData?.restaurantWines).forEach(([productType, wines], typeIndex) => {
                    // Check if we need a new page
                    if (currentWineCount > 0 && currentWineCount + 1 > 4) {
                        pages.push(currentPageContent);
                        currentPageContent = [
                            // <View key="restaurant-header-continued" style={styles.sectionHeader}>
                            //     <Text style={styles.sectionTitle}>Altri Vini</Text>
                            // </View>
                        ];
                        currentWineCount = 0;
                        restaurantTitleShown = false;
                    }

                    // Add product type header with WineBorder
                    currentPageContent.push(
                        <View key={`restaurant-type-${productType}`}>
                            <View style={styles.WineBorder}>
                                {/* {!restaurantTitleShown && typeIndex === 0 && (
                                    <Text style={styles.mainTitleContainer}>Altri Vini</Text>
                                )} */}
                                <Text style={styles.wineType}>{productType}</Text>
                            </View>
                        </View>
                    );
                    restaurantTitleShown = true;

                    // Add wines for this product type
                    wines.forEach(wine => {
                        if (currentWineCount >= 4) {
                            pages.push(currentPageContent);
                            currentPageContent = [
                                // <View key="restaurant-header-continued" style={styles.sectionHeader}>
                                //     <Text style={styles.sectionTitle}>Altri Vini</Text>
                                // </View>,
                                <View key={`restaurant-type-continued-${productType}`} style={styles.WineBorder}>
                                    <Text style={styles.wineType}>{productType}</Text>
                                </View>
                            ];
                            currentWineCount = 0;
                        }
                        currentPageContent.push(renderWineCard(wine));
                        currentWineCount++;
                    });
                });
            }
        }


        // Push the last page
        if (currentPageContent.length > 0) {
            pages.push(currentPageContent);
        }

        return pages.map((pageContent, index) => (
            <Page key={`page-${index}`} size="A4" style={styles.page}>
                <Image style={styles.backgroundImage} src={BannerImg} fixed />
                {logo && index === 0 && (
                    <Image
                        src={{
                            uri: `${apiUrl}/api/v1/proxy-image?url=${encodeURIComponent(logo)}`,
                            method: "GET",
                            headers: { Authorization: `Bearer ${token}` },
                        }}
                        style={styles.LogoImage}
                    />
                )}

                <Image style={styles.LogoImage1} src={img} fixed />

                {index === 0 && <Text style={styles.WineListName}>
                    {truncateText((restData?.wineList?.name || ""), 60)}
                </Text>}

                {index === 0 && restData?.wineList?.is_show_sentence && (
                    <Text style={styles.WineListDescription}>
                        {truncateText((restData?.wineList?.description || "").replace(/[\r\n]+/g, " "), 160)}
                    </Text>
                )}

                <View style={styles.pageContent}>
                    {pageContent}
                </View>
                <Text style={styles.footer} fixed />
            </Page>
        ));
    };


    if (loading) {
        return <div className="flex justify-center items-center h-screen">
            <svg
                aria-hidden="true"
                className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#8B2433]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                />
            </svg>
            <span className="sr-only">Loading...</span>
        </div>
    }


    if (isMobile) {
        return (
            <div className="flex flex-col items-center justify-center h-screen p-4">
                <div className="text-center">

                    <button
                        onClick={handleMobileDownload}
                        disabled={isDownloading}
                        className="px-4 py-2 bg-[#8A2533] text-white rounded-md flex items-center justify-center"
                    >
                        {isDownloading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Downloading...
                            </>
                        ) : (
                            'Download PDF'
                        )}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <PDFViewer style={{ width: '100%', height: '100vh' }}>
            <Document>
                {renderPages()}
            </Document>
        </PDFViewer>
    );
};

export default WinePDF;